export default __webpack_public_path__ + "static/media/home-digital-agency-img-04.49d90613.jpg";